import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import TeamLanding from "../views/TeamLanding";

export default function Team() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<TeamLanding />);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
